import { render } from "./view.vue?vue&type=template&id=77704760&ts=true"
import script from "./view.vue?vue&type=script&lang=ts"
export * from "./view.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Configuration/Users/view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77704760"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77704760', __exports__)) {
    api.reload('77704760', __exports__)
  }
  
  module.hot.accept("./view.vue?vue&type=template&id=77704760&ts=true", () => {
    api.rerender('77704760', render)
  })

}


export default __exports__